import { useState } from "react";
import { ShoppingBag, Menu, X } from "lucide-react";
import { BrandLogo } from "./BrandLogo";
import { LanguageSwitcher } from "./LanguageSwitcher";
import { useLanguage } from "@/i18n/LanguageContext";

export const Navbar = ({ onCartClick, cartCount = 0 }) => {
  const { t } = useLanguage();
  const [open, setOpen] = useState(false);

  const links = [
    { href: "/#produit", label: t("nav.film") },
    { href: "/#configurateur", label: t("nav.configure") },
    { href: "/gallery", label: t("nav.gallery") },
    { href: "/#specifications", label: t("nav.specs") },
    { href: "/#faq", label: t("nav.faq") },
    { href: "/contact", label: t("nav.contact") },
  ];

  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 left-0 right-0 z-40 backdrop-blur-md bg-[#0a0a0a]/80 border-b border-[#2a2422]"
    >
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-12 py-3 flex items-center justify-between">
        <a href="/" data-testid="brand-logo" className="flex items-center group flex-shrink-0">
          <BrandLogo className="h-10 sm:h-12 md:h-14" />
        </a>

        <nav className="hidden lg:flex items-center gap-7 xl:gap-9 text-sm uppercase tracking-[0.18em] text-[#cbc1ad]">
          {links.map((l) => (
            <a key={l.href} href={l.href} className="hover:text-[#d89557] transition">
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <LanguageSwitcher />
          <button
            data-testid="cart-button"
            onClick={onCartClick}
            className="relative flex items-center gap-2 text-[#f4ede0] hover:text-[#d89557] transition"
          >
            <ShoppingBag className="w-5 h-5" />
            <span className="hidden sm:inline text-xs uppercase tracking-[0.18em]">{t("nav.cart")}</span>
            {cartCount > 0 && (
              <span className="absolute -top-2 -right-3 bg-[#b87333] text-[#0a0a0a] text-[10px] font-semibold w-5 h-5 rounded-full flex items-center justify-center">
                {cartCount}
              </span>
            )}
          </button>

          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "Close" : "Open"}
            className="lg:hidden text-[#f4ede0] hover:text-[#d89557] transition p-1"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      <div
        data-testid="mobile-menu"
        className={`lg:hidden overflow-hidden transition-[max-height,opacity] duration-300 ease-out border-t border-[#2a2422] bg-[#0a0a0a]/95 ${
          open ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <nav className="px-6 py-4 flex flex-col gap-1">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="py-3 text-sm uppercase tracking-[0.22em] text-[#cbc1ad] hover:text-[#d89557] border-b border-[#1a1614] last:border-b-0 transition"
            >
              {l.label}
            </a>
          ))}
        </nav>
      </div>
    </header>
  );
};
